import { Component, Input, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { ThemeService } from '../../core/services/theme.service';
import { User } from '../../core/models/user.model';
import { UserRoleType } from '../../core/models/crm-enums';
import { TASK_DISPLAY_STORAGE_KEY } from '../../core/constants';
import { AppDownloadModalComponent } from '../../shared/components/app-download-modal/app-download-modal.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, AppDownloadModalComponent],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  @Input() isCollapsed = false;

  authService = inject(AuthService);
  themeService = inject(ThemeService);
  router = inject(Router);

  readonly UserRoleType = UserRoleType;

  currentUser = computed(() => this.authService.currentUser());

  // Reactive signal that automatically updates when theme changes
  isDarkMode = computed(() => this.themeService.theme() === 'dark');

  openSubmenus: Set<string> = new Set();
  showAppDownloadModal = false;

  constructor() {
  }

  toggleExpanded(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  logout(): void {
    this.authService.logout();
  }

  getUserInitials(username: string): string {
    return username
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }

  toggleSubmenu(submenuKey: string): void {
    if (this.openSubmenus.has(submenuKey)) {
      this.openSubmenus.delete(submenuKey);
    } else {
      this.openSubmenus.add(submenuKey);
    }
  }

  /**
   * Check if a submenu is currently open
   * @param submenuKey - The key identifying the submenu
   * @returns true if the submenu is open
   */
  isSubmenuOpen(submenuKey: string): boolean {
    return this.openSubmenus.has(submenuKey);
  }

  isSubmenuActive(submenuKey: string): boolean {
    if (submenuKey === 'reports') {
      return this.router.url.startsWith('/reports/');
    }

    if (submenuKey === 'products') {
      return this.router.url.startsWith('/products');
    }

    return false;
  }

  private closeAllSubmenus(): void {
    this.openSubmenus.clear();
  }

  toggleSidebar(): void {
    this.isCollapsed = !this.isCollapsed;
    if (this.isCollapsed) {
      this.closeAllSubmenus();
    }
  }

  gettaskDisplayStyle() {
    return localStorage.getItem(TASK_DISPLAY_STORAGE_KEY) ?? ""
  }

}